import '../scss/home.scss';
import { sliderVisibleCard } from '../components/slider-visible-card';

sliderVisibleCard();
